import { formatDate, formatMoney, type Locale } from '@multaqa/i18n'
import type { AuditLogResource } from './api'

type AuditChange = AuditLogResource['changes'][number]

export function auditChangeValue(
  change: AuditChange,
  side: 'old' | 'new',
  locale: Locale,
): string | null {
  const label = side === 'old' ? change.old_label : change.new_label
  const value = side === 'old' ? change.old : change.new
  if (label !== null) return label
  if (value === null) return null
  if (change.kind === 'money') {
    return formatMoney(value, change.currency ?? '', locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }
  if (change.kind === 'date') return formatDate(new Date(`${value.slice(0, 10)}T12:00:00`), locale)
  return value
}
